import { useEffect } from 'react';
import DesktopLayout from '../../../layout/DesktopLayout';
import { useDesktopTopBar } from '../../../../context/DesktopLayoutContext';
import accessImg from '../../../../assets/images/OffersAccessimg.jpeg';

/** Shown in place of any Loyalty screen when the signed-in role isn't permitted. */
export default function LoyaltyAccessRestricted() {
  const setTopBarProps = useDesktopTopBar();

  useEffect(() => {
    setTopBarProps({ title: 'Loyalty Program', breadcrumbs: '' });
  }, [setTopBarProps]);

  useEffect(() => {
    const scrollEl = document.querySelector('[data-desktop-main-scroll]') as HTMLElement | null;
    if (!scrollEl) return;
    scrollEl.style.background = '#fff';
    return () => { scrollEl.style.background = ''; };
  }, []);

  return (
    <DesktopLayout>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          textAlign: 'center',
          minHeight: '70vh',
          padding: 24,
        }}
      >
        <img
          src={accessImg}
          alt=""
          style={{ width: 260, maxWidth: '80%' }}
        />
        <h2
          style={{
            fontSize: 'var(--fs-h2, 20px)',
            fontFamily: 'var(--font-primary)',
            color: 'var(--t1)',
            margin: 0,
            marginBottom: 8,
            fontWeight: 500,
          }}
        >
          Access Restricted
        </h2>
        <p
          style={{
            fontSize: 'var(--fs-body, 16px)',
            fontFamily: 'var(--font-primary)',
            color: 'var(--t1)',
            margin: 0,
            fontWeight: 300,
          }}
        >
          You don't have permission to access this page.
        </p>
      </div>
    </DesktopLayout>
  );
}
